// Phase 75 INV-02 / D-12: FSM ordering — Черновик / Провести оплату / Ожидает оплату / В работе / Оплачен / Отмена платежа / Неактуальный.
// Phase 75 D-38: variant mapping for shared StatusPill (frontend/src/components/StatusPill.tsx).
// Phase 57-03 pattern: text whitelist mirrors backend INVOICE_STATUSES (utils/invoiceFilters.js).
// Phase 3 (2026-06-12): + awaiting_payment and payment_canceled (payment bounced).
// audit-2 2026-07-22: awaiting_payment is NO LONGER manager-accessible (accountant
// territory); payment_canceled is ADMIN/ACCOUNTANT-only, reachable from
// {in_progress, paid, awaiting_payment}, and is a HARD TERMINAL (no transitions out).
//
// Hex defaults match StatusPill PALETTE colors so legacy consumers using `meta.color`
// inline (e.g. ZIP CSV export label) render the same color as the shared pill.
export const INVOICE_STATUS = {
  draft:            { label: 'Черновик',        color: '#94a3b8', order: 0, variant: 'neutral' },
  in_payment:       { label: 'Провести оплату', color: '#f59e0b', order: 1, variant: 'warning' },
  awaiting_payment: { label: 'Ожидает оплату',  color: '#eab308', order: 2, variant: 'yellow'  },
  in_progress:      { label: 'В работе',        color: '#f97316', order: 3, variant: 'orange'  },
  paid:             { label: 'Оплачен',         color: '#10b981', order: 4, variant: 'success' },
  payment_canceled: { label: 'Отмена платежа',  color: '#b91c1c', order: 5, variant: 'darkred' },
  void:             { label: 'Неактуальный',    color: '#ef4444', order: 6, variant: 'danger'  },
};

export const INVOICE_STATUS_VARIANT = {
  draft: 'neutral', in_payment: 'warning', awaiting_payment: 'yellow', in_progress: 'orange',
  paid: 'success', payment_canceled: 'darkred', void: 'danger',
};
export const INVOICE_STATUS_LABEL = {
  draft: 'Черновик', in_payment: 'Провести оплату', awaiting_payment: 'Ожидает оплату',
  in_progress: 'В работе', paid: 'Оплачен', payment_canceled: 'Отмена платежа', void: 'Неактуальный',
};

/** @param {string} status */
export function getInvoiceStatusMeta(status) {
  return INVOICE_STATUS[status] || { label: status || '—', color: '#cbd5e1', order: 99, variant: 'muted' };
}
